






































































import BaseFilter from "@/components/Filter/BaseFilter";
import { PushHistoryFilterParams } from "@/store/push/statistic/types";
import { Component, PropSync, Watch } from "vue-property-decorator";
import { DatePickerWings, FastDateGroupWings, SelectWings } from "wings-ui-components";
import { currentDay, onlyDateFilter } from "@/utils/date-util";
import { Action, Getter } from "vuex-class";
import { notifyError } from "@/utils/notify-helper";
import axios from "axios";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";

@Component({
  components: {FastDateGroupWings, DatePickerWings, SelectWings},
  filters: {onlyDateFilter}
})
export default class PushHistoryFilter extends BaseFilter<PushHistoryFilterParams> {

  @PropSync("show") is_show_primary!: boolean;
  @PropSync("filterClone") propFilterClone!: PushHistoryFilterParams;
  @PropSync("runFilter") propRunFilter!: boolean;

  @Action("getPushApplications") actionGetApplications: any;
  @Action("getPushHistories") actionGetStatistic: any;
  @Action("getPushOS") actionGetPushOS: any;
  @Action("actionLog") actionLog: any;

  @Getter("pushApplications") pushApplicationsList: any;
  @Getter("pushOS") pushOSList: any;

  defaultFilter(): PushHistoryFilterParams {
    return new PushHistoryFilterParams(currentDay(), currentDay());
  }

  async created() {
    try {
      await this.actionGetApplications();
      await this.actionGetPushOS();
    } catch (err) {
      notifyError(err);
    }
  }

 async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Subscriptions",
        addititional_info: getTranslatedParams(this.filter)
      };
      await this.actionGetStatistic(this.filter);
      await this.actionLog(this.logObject);
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    }
  }

  @Watch('filter', { immediate: true, deep: true })
  onFilterChange(val: PushHistoryFilterParams) {
    this.propFilterClone = val;
  }

  @Watch('runFilter', { immediate: true })
  onRunFilterChange(val: boolean) {
    if (val) {
      this.filtered();
      this.propRunFilter = false;
    }
  }
}
